import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getResetPasswordToken } from 'services/auth';
import YM from 'utils/metrics';
import { validateValue, VALIDATION_TYPES } from 'utils/validation';
import Button from 'components/Button';
import Card from 'components/Card';
import Input from 'components/Input';
import ModalError from 'components/Modals/ModalError';

import classes from './forgotPassword.module.scss';

const ResetPassword: React.FC = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

	const validateEmail = (value: string): boolean => {
		const newError = validateValue({
			type: VALIDATION_TYPES.EMAIL,
			value,
			isRequired: true,
		});
		setError(newError);
		const isValid = !newError;
		return isValid;
	};

	const handleChangeEmail = (value: string): void => {
		setEmail(value);
		validateEmail(value);
	};

	const handleSubmit = async (
		e: React.FormEvent<HTMLFormElement>
	): Promise<void> => {
		e.preventDefault();
		if (isLoading) return;

		const isValid = validateEmail(email);
		if (!isValid) return;

		setIsLoading(true);
		try {
			await getResetPasswordToken({ email });
			YM.onFormSubmit();
			navigate('../reset-password');
		} catch (e) {
			setIsErrorModalOpen(true);
		}
		setIsLoading(false);
	};

	const handleToggleErrorModal = (): void => {
		setIsErrorModalOpen(!isErrorModalOpen);
	};

	const formInputs = (
		<div className={classes.formInputs}>
			<Input
				className={classes.email}
				value={email}
				onChange={handleChangeEmail}
				type="text"
				placeholder="Почта"
				error={error}
			/>
		</div>
	);

	const formButtons = (
		<div className={classes.formButtons}>
			<Button
				className={classes.button}
				text="Отправить ссылку"
				type="submit"
				isLoading={isLoading}
			/>
			<div className={classes.separator}>
				<div className={classes.separatorText}>Или</div>
			</div>
			<Button
				className={classes.buttonLink}
				text="Войти"
				href="../login"
				styleType="secondary"
			/>
		</div>
	);

	const form = (
		<form className={classes.form} onSubmit={handleSubmit}>
			{formInputs}
			{formButtons}
		</form>
	);

	return (
		<Card
			className={classes.forgotPassword}
			title="Введите адрес электронной почты"
			titleClassName={classes.title}
			subtitle="На указанный адрес будет отправлена ссылка для восстановления пароля"
			subtitleClassName={classes.subtitle}
		>
			{form}
			<ModalError
				className={classes.modal}
				isOpen={isErrorModalOpen}
				onClose={handleToggleErrorModal}
				text="Пользователь не найден"
			/>
		</Card>
	);
};

export default ResetPassword;
